import { render, staticRenderFns } from "./EmailText.vue?vue&type=template&id=5e8a8fd4&"
import script from "./EmailText.vue?vue&type=script&lang=js&"
export * from "./EmailText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports